export enum ApprovalHierarchyType {
  Default = 0,
  Dealer = 1,
  Regions = 2,
  Automaker = 3
}

